import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import { searchUpdate, clear, updateTerm } from '../modules/searchdata';
import { useTranslation } from 'react-i18next';

let timerHandle = null;

export default function SearchField(props) {
    const { t } = useTranslation();
    const theme = useTheme();
    const dispatch = useDispatch();
    const term = useSelector((state) => state.searchdata.searchTerm);

    const goToSearchResultsPage = useCallback(() => {
        if (props.history.location.pathname.toLowerCase().search('search') !== -1) {
            props.history.replace('/search/' + encodeURIComponent(term));
        } else {
            props.history.push('/search/' + encodeURIComponent(term));
        }
    }, [props.history, term]);

    const goToPreviousPage = useCallback(() => {
        if (props.history.location.pathname.toLowerCase().search('search') !== -1) {
            props.history.goBack();
        }
    }, [props.history]);

    useEffect(() => {
        if (term.length > 3) {
            timerHandle = setTimeout(() => {
                goToSearchResultsPage();
                dispatch(searchUpdate(term));
            }, 1000);
        }
        if (term.length === 0) {
            goToPreviousPage();
            dispatch(clear());
        }

        return () => {
            if (timerHandle) {
                clearTimeout(timerHandle);
                timerHandle = null;
            }
        };
    }, [term, dispatch, goToPreviousPage, goToSearchResultsPage]);

    const setTerm = (newTerm) => {
        dispatch(updateTerm(newTerm));
    };

    const onChange = (evt) => {
        setTerm(evt.target.value);
    };

    const onCancel = () => {
        setTerm('');
    };

    return (
        <Box
            sx={{
                position: 'relative',
                borderRadius: theme.shape.borderRadius,
                backgroundColor: alpha(theme.palette.common.white, 0.15),
                '&:hover': { backgroundColor: alpha(theme.palette.common.white, 0.25) },
                mr: 1,
                ml: { xs: 0, sm: 2 },
                width: { xs: '100%', sm: 'auto' },
            }}>
            <Box
                sx={{
                    p: '0 8px',
                    height: '100%',
                    position: 'absolute',
                    pointerEvents: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <SearchIcon />
            </Box>

            <InputBase
                placeholder={t('searchHint')}
                sx={{
                    color: 'inherit',
                    '& .MuiInputBase-input': {
                        py: 1,
                        pl: 4,
                        pr: 4,
                        transition: theme.transitions.create('width'),
                        width: { xs: '100%', md: '200px' },
                    },
                }}
                name="global-search-input"
                value={term}
                inputProps={{ 'aria-label': 'search' }}
                onChange={onChange}
            />
            {term.length > 0 && (
                <Box
                    sx={{
                        p: '0 8px',
                        height: '100%',
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        top: 0,
                        left: 'calc(100% - 40px)',
                        cursor: 'pointer',
                    }}>
                    <CancelIcon name="btn-cancel" onClick={onCancel} />
                </Box>
            )}
        </Box>
    );
}
